import React, { useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntity } from './matiere-ecole.reducer';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const MatiereEcoleDetail = (props: RouteComponentProps<{ ecoleid: string; id: string }>) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);

  const matiereEntity = useAppSelector(state => state.matiereEcole.entity);

  const goBack = () => props.history.goBack();
  return (
    <Row className="justify-content-center">
      <Col md="8">
        <h2 data-cy="matiereDetailsHeading">
          <Translate contentKey="korischoolApp.matiere.detail.title">Matiere</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{matiereEntity.id}</dd>
          <dt>
            <span id="nom">
              <Translate contentKey="korischoolApp.matiere.nom">Nom</Translate>
            </span>
          </dt>
          <dd>{matiereEntity.nom}</dd>
          <dt>
            <span id="color">
              <Translate contentKey="korischoolApp.matiere.color">Color</Translate>
            </span>
          </dt>
          <dd style={{ backgroundColor: matiereEntity.color }}>{matiereEntity.color} </dd>
        </dl>
        <Button onClick={goBack} color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/matiere-ecole/${matiereEntity.ecoleId}/${matiereEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default MatiereEcoleDetail;
